/* UGC「用户实拍」模块控制器（snippets/pg-cv2-ugc.liquid 的 <pg-cv2-ugc>）：新版集合页与 Sale 页共用。
   2026-10-20 PG-SALE-1020-A0 自 pg-collection-experience.js 搬出：PC 箭头轮换缩略图、手机圆点联动横滑、放大镜灯箱。 */
(() => {
  if (customElements.get('pg-cv2-ugc')) return;

  class PGCv2Ugc extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true });
      } else this.initialize();
    }

    initialize() {
      if (!this.isConnected) return;
      this.listeners = new AbortController();
      this.boundDialogs = new WeakSet();
      this.ownedScrollLock = false;
      this.addEventListener('click', (event) => this.onClick(event), { signal: this.listeners.signal });
      // 模块自带的灯箱（Sale 页）由本元素管关闭；集合页的灯箱在页面 section 里，由页面控制器管（见 openLightbox）。
      const ownDialog = this.querySelector('[data-cv2-lightbox]');
      if (ownDialog) this.bindDialog(ownDialog);
      this.initializeGallery();
    }

    disconnectedCallback() {
      this.listeners?.abort();
      this.setScrollLock(false);
      this.started = false;
    }

    onClick(event) {
      const target = event.target.closest('button');
      if (!target || !this.contains(target)) return;
      if (target.matches('[data-cv2-zoom]')) this.openLightbox(target);
      else if (target.matches('[data-cv2-feature-step]')) this.stepGallery(target);
      else if (target.matches('[data-cv2-gallery-dot]')) {
        const gallery = this.querySelector('[data-cv2-gallery]');
        const card = gallery.children[Number(target.dataset.cv2GalleryDot)];
        gallery.scrollTo({ left: card.offsetLeft - gallery.firstElementChild.offsetLeft, behavior: this.reducedMotion() ? 'auto' : 'smooth' });
      }
    }

    openLightbox(trigger) {
      const source = trigger.closest('.pg-cv2-ugc__item').querySelector('picture>img');
      if (!source?.complete || source.naturalWidth === 0) return;
      const dialog = this.querySelector('[data-cv2-lightbox]') || document.querySelector('[data-cv2-lightbox]');
      if (!dialog) return;
      const image = dialog.querySelector('img[data-cv2-lightbox-image]');
      image.src = source.currentSrc || source.src;
      image.alt = source.alt;
      // 页面控制器（如新版集合页）接住事件就由它打开，统一管滚动锁与焦点；没人接（Sale 页）时模块自己打开。
      const request = new CustomEvent('pg-cv2:open-dialog', { bubbles: true, cancelable: true, detail: { dialog, trigger } });
      if (this.dispatchEvent(request)) this.openDialog(dialog, trigger);
    }

    bindDialog(dialog) {
      if (this.boundDialogs.has(dialog)) return;
      this.boundDialogs.add(dialog);
      dialog.addEventListener('close', () => this.onDialogClose(dialog), { signal: this.listeners.signal });
      dialog.addEventListener('click', (event) => {
        const box = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
      }, { signal: this.listeners.signal });
      dialog.querySelector('[data-cv2-dialog-close]')?.addEventListener('click', () => dialog.close(), { signal: this.listeners.signal });
    }

    openDialog(dialog, trigger) {
      this.bindDialog(dialog);
      dialog.cv2Trigger = trigger;
      trigger.classList.add('is-active');
      dialog.showModal();
      this.setScrollLock(true);
    }

    onDialogClose(dialog) {
      dialog.cv2Trigger?.classList.remove('is-active');
      dialog.cv2Trigger?.focus({ preventScroll: true });
      dialog.cv2Trigger = null;
      this.setScrollLock(false);
    }

    setScrollLock(locked) {
      if (locked && !this.ownedScrollLock) { this.previousOverflow = document.body.style.overflow; this.ownedScrollLock = true; document.body.style.overflow = 'hidden'; }
      else if (!locked && this.ownedScrollLock) { document.body.style.overflow = this.previousOverflow; this.ownedScrollLock = false; }
    }

    initializeGallery() {
      const gallery = this.querySelector('[data-cv2-gallery]');
      if (!gallery) return;
      const dots = this.querySelector('[data-cv2-gallery-dots]');
      dots.replaceChildren();
      [...gallery.children].forEach((item, index) => {
        const dot = document.createElement('button');
        dot.type = 'button'; dot.dataset.cv2GalleryDot = String(index);
        dot.setAttribute('aria-label', `${this.dataset.galleryLabel || 'Photo'} ${index + 1}`);
        dot.setAttribute('aria-pressed', String(index === 0)); dots.append(dot);
      });
      gallery.addEventListener('scroll', () => {
        const index = [...gallery.children].reduce((best, item, i, arr) => Math.abs(item.offsetLeft - arr[0].offsetLeft - gallery.scrollLeft) < Math.abs(arr[best].offsetLeft - arr[0].offsetLeft - gallery.scrollLeft) ? i : best, 0);
        dots.querySelectorAll('button').forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
      }, { passive: true, signal: this.listeners.signal });
    }

    // PC 缩略图每屏 3 张，箭头循环轮换（运营反馈：主图固定不变）。
    stepGallery(button) {
      const gallery = this.querySelector('[data-cv2-gallery]');
      const items = [...gallery.children];
      if (items.length < 2) return;
      if (Number(button.dataset.cv2FeatureStep) > 0) gallery.append(items[0]);
      else gallery.prepend(items.at(-1));
    }

    reducedMotion() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  }

  customElements.define('pg-cv2-ugc', PGCv2Ugc);
})();
